import { LmIconOutlineMapMap } from '@mes-ui/lemma/icons';

const IconMapFilled = (props: React.SVGProps<SVGSVGElement>) => <LmIconOutlineMapMap {...props} />;

export default IconMapFilled;
